//引入封装好的 axios
import Axios from './axios'



//上传文件
function uploadFile(url,file) {
    const formData = new FormData();
    formData.append('file', file); // 'file' 对应服务器接收字段名

    const xhr = new XMLHttpRequest();

    // 上传进度监听
    xhr.upload.addEventListener('progress', (e) => {
        if (e.lengthComputable) {
            const percent = Math.round((e.loaded / e.total) * 100);
            console.log(`上传进度: ${percent}%`);
        }
    });

    // 状态变化监听
    xhr.addEventListener('readystatechange', () => {
        if (xhr.readyState === 4) {
            if (xhr.status === 200) {
                console.log('上传成功:', JSON.parse(xhr.responseText));
            } else {
                console.error('上传失败:', xhr.statusText);
            }
        }
    });

    xhr.open('POST', url, true); // 替换为实际API地址
    xhr.send(formData);
}

//实例化
const instance = Axios()
//创建需要的请求方法:get post put delete
//url:请求的接口地址
//params:请求参数
//headers:请求头
export default {
    get(url, params) {
        return instance.get(url, {params:params})
    },
    post(url, params, headers) {
        return instance.post(url, params, {headers});
    },
    put(url, params, headers) {
        return instance.put(url, params, {headers})
    },
    delete(url, params, headers) {
        return instance.delete(url, {params, headers})
    },
    updateFile(url,file) {
        return uploadFile(url, file)
    }
}